import appApi from '../../../../../api/app-api';
import { ProfessorCourseFeedbacksFilterType } from '../side-bar-filter/professor-course-feedbacks-filter.type';
import { toast } from 'react-toastify';
import { displayErrorText } from '../../../../../api/errors/api-error-codes';
import { PollsReportDb } from '../../../../../api/types/reports/education/professor-course-poll-feedbacks/professor-course-poll-feedbacks';
import { ProfessorCourseFeedbackRow } from '../professor-course-feedbacks';

const mapPollsReportData = (
  data: PollsReportDb[],
): ProfessorCourseFeedbackRow[] => {
  return data.map((item) => ({
    branchName: item.branchName,
    courseName: item.courseName,
    courseStatus: item.status,
    courseStartDate: item.courseStartDate
      ? new Date(item.courseStartDate).toLocaleDateString('he-IL')
      : '-',
    pollName: item.settingsAbstractPollPollName,
    professorName: `${item.professorFirstName} ${item.professorLastName}`,
    professorId: item.professorId,
  }));
};

export const getProfessorCourseFeedbacksOperation = async (
  filters: ProfessorCourseFeedbacksFilterType,
  setData: (data: ProfessorCourseFeedbackRow[]) => void,
  setLoading: (loading: boolean) => void,
) => {
  try {
    setLoading(true);
    const response = await appApi.getProfessorCoursePollsReport(filters);
    if (response.data.errCode) {
      toast.warn(displayErrorText(response.data.errCode));
      setLoading(false);
      return;
    }
    const body = response.data.body;
    setData(mapPollsReportData(body));
    setLoading(false);
  } catch (e) {
    setLoading(false);
    console.error(
      `getProfessorCourseFeedbacksOperation failed with the filters: ${JSON.stringify(filters)} and the error: ${e}`,
    );
    toast.error('משהו קרה, יש לנסות שוב בעוד מספר רגעים');
    throw e;
  }
};
